import React from 'react';

import { Container, Image } from './styles';

interface CardImageProps {
    className?: string;
    src?: string;
    isPreview?: boolean;
}
export const CardImage = ({ className, isPreview = false, src }: CardImageProps) => (
    <Container className={className} disabled={isPreview} key={src}>
        {src ? <Image src={src} alt="Product image" /> : null}
    </Container>
);
